import { useIntl } from "react-intl";

type Props = {
  idPrefix?: string;
  isLoading: boolean;
  count?: number;
  maximum?: number;
};

export default function CountBadge({
  isLoading,
  count = 0,
  maximum = 0,
  idPrefix = "",
}: Props) {
  const intl = useIntl();
  const id = `${idPrefix}count-badge-loading`;
  const badge = isLoading ? (
    <span id={id} className="loading" data-testid={`${id}-testid`}>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  ) : (
    `${intl.formatNumber(count)}${maximum > 0 && count === maximum ? "+" : ""}`
  );

  return <span className="badge">{badge}</span>;
}
